import React from 'react'
import { ModalProps } from '../../interfaces/modal';
import { usePaymentStore } from '../../stores/payment';
import { getSepa } from '../../api/banks';
import { showToastError, showToastSuccess } from '../../services/toast';
import { ModalButton, ModalConfirmText, ModalShell } from '../ui/modals/ModalShell';

const SEPA : React.FC<ModalProps> = ({ closeModal })=> {
    const { updatePaymentBool, setUpdatePaymentBool} = usePaymentStore();

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    getSepa(2)
    .then((res) => {
        showToastSuccess("Fichier SEPA généré, encaissements générés");
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = "sepa.xml";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        setUpdatePaymentBool(!updatePaymentBool)
        closeModal();
    })
    .catch((error) => {
        if(error.response.data.message === "Aucune facture non soldée trouvée pour les clients avec mandat actif") {
            showToastError("Aucune facture non soldée trouvée pour les clients avec mandat actif");
        } else {
            showToastError("Une erreur est survenue");
        }
    })
  };
  
    return (
        <ModalShell
          title="Export SEPA"
          size="sm"
          onClose={() => closeModal()}
          footer={
            <>
              <ModalButton variant="secondary" onClick={() => closeModal()}>
                Annuler
              </ModalButton>
              <ModalButton
                variant="primary"
                type="submit"
                onClick={(e) => handleSubmit(e)}
              >
                Créer
              </ModalButton>
            </>
          }
        >
          <ModalConfirmText>
            Génération de l'export XML pour les prélèvements SEPA.
          </ModalConfirmText>
          <p className="mt-3 rounded-xl bg-amber-50 px-3 py-2 text-center font-Nunito text-xs text-amber-800 ring-1 ring-amber-100 ring-inset">
            Cette action générera automatiquement les lignes d'encaissement associées.
          </p>
        </ModalShell>
      );
}

export default SEPA
